import { formatCurrency } from "@common/helpers/numberFormatting";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";

type WithValueOfAndAffirmProps = {
  valuePerMonth: number;
};

type WithPaymentTermProps = {
  payment: number;
  paymentTerm: number;
  downPayment: number;
};

type Props = WithValueOfAndAffirmProps & WithPaymentTermProps;

const WithPaymentTerm = ({
  payment,
  paymentTerm,
  downPayment,
}: WithPaymentTermProps) => {
  const { t } = useTranslation(["common", "purchase"]);
  const locale = useRouter().locale || "en";

  return (
    <div className="w-full rounded-md mb-2 bg-gray-25 p-6 pb-4 text-primary-deep">
      <div className="flex items-baseline mb-1 gap-x-1.5">
        <span className="text-center text-6xl font-semibold ">
          {formatCurrency(payment, locale, {
            showCents: "never",
          })}
        </span>
        <span className="text-2xl font-semibold">
          {t("purchase:per_month", { amount: "" })}
        </span>
      </div>
      <div className="caption-2 leading-5">
        {t("purchase:based_on_a_term", {
          term: paymentTerm,
          downPayment: formatCurrency(downPayment, locale, {
            showCents: "never",
          }),
        })}
      </div>
    </div>
  );
};

const Free = () => {
  const { t } = useTranslation(["common"]);
  return (
    <div className="w-full flex items-center justify-center rounded-md mb-2 bg-gray-25 p-4 h-32">
      <h1>{t("common:free").toUpperCase()}!</h1>
    </div>
  );
};

const CostPerMonthCoverage = ({
  valuePerMonth,
  payment,
  downPayment,
  paymentTerm,
}: Props) => {
  if (payment === 0 || valuePerMonth === 0) {
    return <Free />;
  }

  return (
    <WithPaymentTerm
      payment={payment}
      downPayment={downPayment}
      paymentTerm={paymentTerm}
    />
  );
};

export default CostPerMonthCoverage;
